export default "__VITE_ASSET__DKfCp6RH__"